const http = require('../lib/httpClient');
const { getChannelId, getEcommId, getXCommerceValue } = require('../lib/browserData');
const { LOGIN_STATUS, COMMERCE_HEADER } = require('../constants');

const { decodeJWT } = require('../utils/decoder');

const catalystLoginError = {
  code: 'CATALYST_LOGIN_ERROR',
  message: 'Unable to login',
};

const softLoginEndpoint = '/s/auth/v1/soft/login';

async function catalystSoftLogin(emailAddress, tenantId, additionalInfo, catalystBaseUrl = '') {
  const result = await http.post(
    `${catalystBaseUrl}${softLoginEndpoint}`,
    { emailAddress },
    {
      headers: {
        'x-channel-id': getChannelId(),
        'x-ecomm-name': getEcommId(tenantId, additionalInfo),
        'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
      },
    },
  );

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [catalystLoginError] };
  const { idToken: sessionJWT, errors } = responseBody;
  if (errors) return { data: undefined, errors };
  const sessionData = decodeJWT(sessionJWT);
  const { session: { status: sessionStatus } = {} } = sessionData;
  if (sessionStatus !== LOGIN_STATUS.SOFT) {
    return {
      data: undefined,
      errors: [
        {
          code: 'LOGIN_ERROR_NON_SOFT_LOGIN',
          message: 'User not soft logged in',
        },
      ],
    };
  }
  return { data: { ...responseBody, ...sessionData }, errors: [] };
}

module.exports = catalystSoftLogin;
